import script from "./VocabularyTestModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./VocabularyTestModal.vue?vue&type=script&setup=true&lang=ts"

import "./VocabularyTestModal.vue?vue&type=style&index=0&id=02c82b46&scoped=true&lang=less"

import exportComponent from "../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02c82b46"]])

export default __exports__